import { IInfinitePageStatisticsResponse } from 'services/types';

export interface IRepaymentFormData {
  description: string;
  amount: string | number;
  maximumRepaymentPercentage: string | number;
  forSignature: boolean | undefined;
  repaymentsFromAllContracts: boolean | string;
  LabelId: string;
  contracts: string[];
  residenceCertificate?: boolean | string;
  statusId?: boolean;
}
export interface IContractLabelResponse {
  contracts: IContractLable[];
  totalPageCount: number;
}

export interface IInfinityLabelParam {
  page: number;
  itemCount?: number;
  labelId: string;
  pageCount?: number;
}

export interface IContractLable {
  id: string;
  labelId: string;
  title: string;
  status: number;
  startDate: string;
  endDate: string | null;
}

export enum SIGNATURE_TYPE {
  true = 'signed',
  false = 'unsigned',
}

export enum REPAYMENTS_TYPE {
  true = 'Yes',
  false = 'No',
}

interface RepaymentSource {
  name: string;
  id: number;
}

interface RepaymentDocument {
  number: {
    shortcut: string;
    number: number;
    month: number;
    year: number;
    value: string;
  };
  id: string;
  fileName: string;
  path: string;
  sizeInMB: number;
  createdAt: string;
  extension: string;
  mD5Hash: string;
}

interface Repayment {
  amount: number;
  repaymentDate: string;
  settlementId: string | null;
  repaymentSource: RepaymentSource;
  repaymentSourceId: string;
  repaymentDocument: RepaymentDocument;
  isPaidFromNet: boolean;
}

interface Contract {
  id: string;
  title: string;
}

export interface IAdvance {
  id: string;
  settlementId: string;
  settlementNumber: string | null;
  date: string;
  amount: any;
  remainingNetAmount: number;
  advanceNumber: string;
  description: string;
  forSignature: boolean | string;
  repaymentsFromAllContracts: boolean | string;
  proposalAdvanceDocumentPath: string;
  finalAdvanceDocumentPath: string;
  maximumRepaymentPercentage: number | null;
  repayments: Repayment[];
  contracts: Contract[];
  settlementPeriodId: string;
  settlementPeriod: {
    name: string;
    year: number;
  } | null;
  finalDocumentNumber: string;
  version: number;
  isSettled: boolean;
}

export interface IAdvanceStatistics {
  allAmount: 1584;
  allRemainingNetAmount: 1584;
}

export interface IAdvanceByLabelResponseInfinite
  extends IInfinitePageStatisticsResponse<IAdvance, IAdvanceStatistics> {}

export interface IUnapidBase {
  id?: string;
  labelName?: string;
  labelId: string;
}

export interface IUnpaidAdvance extends IUnapidBase {
  remainingNetAmount: number;
  advanceProposalNumber?: string;
  amount: number;
}

export interface IUnpaidAdvanceStatistic {
  allNetAmount: number;
}

export interface IRepaymentPopupForm {
  amount: number;
  totalRepayment: boolean;
}

export interface IAdvanceRepayment extends IRepaymentPopupForm {
  advanceId: string;
  version: number;
}

export interface IAdvanceUpdateRequest {
  advanceId: string;
  version: number;
  labelId: string;
  amount: number;
  maximumRepaymentPercentage: number;
  description: string;
  forSignature: boolean;
  repaymentsFromAllContracts: boolean;
  contracts: string[];
  settlementPeriodId: string;
}